import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { saveSingle } from "../../services/tourService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import { Table } from "semantic-ui-react";
import TableTitle from "../common/tableTitle";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class TourForm extends Form {
  state = {
    preferredDate: new Date(),
    data: {
      parent_first_name: "",
      parent_last_name: "",
      child_name: "",
      child_age: "",
      phone: "",
      email: "",
    },
    errors: {}
  };

  schema = {
    id: Joi.string(),
    parent_first_name: Joi.string()
      .required()
      .label("Parent First Name"),
      parent_last_name: Joi.string()
      .required()
      .label("Parent Last Name"),
      child_name: Joi.string()
      .required()
      .label("Child Name"),
      child_age: Joi.string()
      .required()
      .label("Child Age"),
      phone: Joi.string()
      .required()
      .label("Phone"),
      email: Joi.string()
      .required()
      .label("Email"),
      
  };

  doSubmit = async () => {
    try {
      // this.setState({ blocking: true });
      // await saveSingle(this.state.data);

      let formData = new FormData();
      formData.append("parent_first_name", this.state.data.parent_first_name);
      formData.append("parent_last_name", this.state.data.parent_last_name);
      formData.append("child_name", this.state.data.child_name);
      formData.append("child_age", this.state.data.child_age);
      formData.append("phone", this.state.data.phone);
      formData.append("email", this.state.data.email);
      
      var event = new Date(this.state.preferredDate);
      let date = JSON.stringify(event);
      date = date.slice(1, 11);
      formData.append("preferred_tour_date", date);

      await saveSingle(formData);

      toast.success("Tour has been added successfully.");
      this.setState({ blocking: false });
      this.props.history.push("/web/tours");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        if (ex.response.data.errors.address)
          errors.address = ex.response.data.errors.address;

        if (ex.response.data.errors.phone)
          errors.phone = ex.response.data.errors.phone;

        if (ex.response.data.errors.account)
          errors.account = ex.response.data.errors.account;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  handleChangePreferredDate = date => {
    this.setState({
      preferredDate: date
    });
  };

  render() {
    const dashboardIcon = process.env.REACT_APP_URL + "/new_theme/bank.png";
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <TableTitle title="Add tour" icon="tag" color="white" iconPath={dashboardIcon} />
        <center>
          <form
            onSubmit={this.handleSubmit}
            className="ui error form"
            style={{ width: "50%" }}
          >
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell colSpan="3">Add tour</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row>
                  <Table.Cell width="8">
                    {this.renderInput("parent_first_name", "Parent First Name", "text")}
                  </Table.Cell>
                  <Table.Cell width="8">
                    {this.renderInput("parent_last_name", "Parent Last Name", "text")}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell width="8" style={{ verticalAlign:'top' }}>
                    {this.renderInput("child_name", "Child Name", "text")}
                  </Table.Cell>
                  <Table.Cell width="8">
                    {this.renderInput("child_age", "Child Age", "text")}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell width="8" style={{ verticalAlign:'top' }}>
                    {this.renderInput("phone", "Phone", "text")}
                  </Table.Cell>
                  <Table.Cell width="8">
                    {this.renderInput("email", "Email", "text")}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell width="8">

                    <label>
                      Preferred Tour Date
                    </label>
                    <br />
                    <DatePicker
                      selected={this.state.preferredDate}
                      onChange={this.handleChangePreferredDate}
                    />
                    <br />
                    <small>(day/month/year)</small>

                  </Table.Cell>
                  <Table.Cell width="8">
                   
                  </Table.Cell>
                </Table.Row>
                
                <Table.Row>
                  <Table.Cell>
                    {this.renderButton("Save")}
                    <Link to="/web/tours" className="ui secondary button">
                      Back
                    </Link>
                  </Table.Cell>
                  <Table.Cell></Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </form>
        </center>
      </BlockUi>
    );
  }
}

export default TourForm;
